import { render } from "./DatasetSelectType.vue?vue&type=template&id=52c8784b"
import script from "./DatasetSelectType.vue?vue&type=script&lang=js"
export * from "./DatasetSelectType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__